'use strict';

angular.module('licensure.portal')
    .directive('portalHeader', [function () {
        return {
            restrict: 'E',
            templateUrl: paths.app + 'components/header/header.html',
            controller: ['$scope', '$state', '$rootScope', '$sce', 'CMSSites', 'CMSPages', 'Format', 'EnterpriseLinkService', function ($scope, $state, $rootScope, $sce, CMSSites, CMSPages, Format, EnterpriseLinkService) {

                $scope.editing = false;

                if ($rootScope.site) {
                    $scope.site = $rootScope.site;
                    if ($rootScope.portalCSS) {
                        $scope.site.public_portal_css = $rootScope.portalCSS;
                    }
                    else {
                        // render the CSS
                        $scope.site.public_portal_css = Format.buildCSS($scope.site.public_portal_css, true);
                    }
                }

                if ($rootScope.enterprise) {
                    $scope.enterprise = $rootScope.enterprise;
                    if ($rootScope.portalURL) {
                        $scope.portalURL = $rootScope.portalURL;
                    }
                    else {
                        $scope.portalURL = $scope.enterprise.website;
                        $rootScope.portalURL = $scope.enterprise.website;
                    }
                }

                if ($scope.site) {
                    if (!$scope.site.public_portal_header) {
                        $scope.site.public_portal_header = "";
                    }
                    CMSPages.getMenu({ site_id: $scope.site.id, is_public: true }).then(function (pages) {
                        EnterpriseLinkService.get().then(function (links) {
                            $scope.menuPages = pages;
                            $scope.links = links;
                        });
                    });
                }
                else {
                    $scope.site = {};
                }

                if (!$scope.site.public_portal_header) {
                    $scope.site.public_portal_header = "";
                }

                $scope.renderHtml = function (htmlCode) {
                    if (typeof htmlCode == "string") {
                        return $sce.trustAsHtml(htmlCode);
                    }
                    return "";
                }
                $scope.underscore = function (phrase) {
                    return Format.underscore(phrase);
                }

                $scope.edit = function () {
                    var isInIframe = (parent !== window);
                    if (isInIframe) {
                        if (window.parent.location.href.includes($rootScope.enterprise.site_location + "license/admin/public_portal/layout.cfm")) {
                            $scope.editing = true;
                        }
                    }
                }

                $scope.close = function () {
                    $scope.editing = false;
                }

                $scope.customPage = function (linkId) {
                    $scope.loading = true;
                    $state.go('portal.menus.linkpage', { id: linkId });
                }

                $scope.saveHeader = function () {
                    $scope.headerSaving = true;
                    CMSSites.save($scope.site).then(function (result) {
                        $scope.headerSaving = false;
                        $scope.editing = false;
                    });
                }
            }],
            replace: true,
            link: function (scope, elem, attrs, ctrl) {
                scope.toggleMenu = function () {
                    var nav = angular.element(document.querySelector("#licensure .navigation"));
                    if (nav.css('display') == 'none' || nav.css('display') == '') {
                        nav.css('display', 'block');
                    }
                    else {
                        nav.css('display', 'none')
                    }

                    angular.element(document.querySelector("#licensure .menu.mobile")).toggleClass('expand');
                }
            }
        };
    }])
    ;